import dayjs from 'dayjs';

import { useForm } from '@mantine/form';

import { selectPersonId } from '@/store/user-process/user-selectors.ts';

import { TODAY } from '@/shared/constant/app';
import useAppStore from '@/shared/store/app.store.ts';
import useBookingStore from '@/shared/store/booking.store.ts';
import { TDateRange } from '@/shared/types/app.types';
import { IGuest } from '@/shared/types/booking.types';
import { BookingType } from '@/shared/types/bookingObjects.types';

import { getNearestDate } from '@/utils/date';

import { useAppSelector } from '@/hooks';

export type TWorkPlaceForm = {
	booking_object_id?: number | null;
	client_id: number | undefined;
	date: TDateRange;
	kind: BookingType;
	is_guest?: boolean;
	guests?: IGuest[];
};

export const useWorkPlaceForm = () => {
	const date = useAppStore((state) => state.date);
	const { bookingPlace } = useBookingStore();
	const personId = useAppSelector(selectPersonId);

	const form = useForm<TWorkPlaceForm>({
		initialValues: {
			date: [
				(dayjs(date[0]).isToday() ? getNearestDate(TODAY) : dayjs(date[0])).toDate(),
				(dayjs(date[1]).isAfter(TODAY)
					? dayjs(date[1])
					: getNearestDate(TODAY).endOf('day')
				).toDate(),
			],
			// date: [
			// 	(dayjs(date[0]).isToday() ? getNearestDate(TODAY) : dayjs(workTime[0])).toDate(),
			// 	// (dayjs(date[1]).isAfter(TODAY)
			// 	// 	? dayjs(date[1])
			// 	// 	: getNearestDate(TODAY).endOf('day')
			// 	// ).toDate(),
			// 	dayjs(date[1]).isToday()
			// 		? dayjs(date[0]).add(1, 'hour').toDate()
			// 		: dayjs(workTime[1]).toDate(),
			// ],
			client_id: personId,
			booking_object_id: bookingPlace?.id,
			kind: 'work_place',
			is_guest: false,
			guests: [],
		},
		validate: {
			client_id: (value) => (!value ? 'Invalid client_id' : null),
			booking_object_id: (value) => (!value ? 'Invalid booking_object_id' : null),
		},
	});

	return form;
};
